const SnackbarTypeEnum = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
}

export default SnackbarTypeEnum;
